// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingIndicator_container__y2oiD","spin":"LoadingIndicator_spin__sWWjk"};